import './XYChartCrosshair.css';
export var crosshair = '_1i6pn1r0-2-0-1';